export const defaultTableHeaderStyles = {
    backgroundColor: "var(--vschool-2026-header)",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultPaginationOptions = {
    sizePerPage: 15,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const defaultTableOptions = {
striped: true ,
bordered: false,
hover: true,
rowStyle: {
    color: "#605F5E",
    textAlign: "left",
    fontSize: "14px",
    margin: "10px"
}} ;